import { render, staticRenderFns } from "./manage-booking-cancel-header.vue?vue&type=template&id=512ceeda&scoped=true"
import script from "./manage-booking-cancel-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-booking-cancel-header.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-booking-cancel-header.vue?vue&type=style&index=0&id=512ceeda&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ceeda",
  null
  
)

export default component.exports